import { CircularProgress, Paper, Typography } from '@mui/material';
import {
  formatAvailityLoaderTimeWarn,
  getAvailityVobProcessingRetryMinutes,
} from '../../estimates/components/patient/patient-form/utils/availity-vob';
import './availity-loader.scss';

interface AvailityLoaderProps {
  showLoader?: boolean;
  customMessage?: string;
  /** Override minutes for tests; defaults to REACT_APP_AVAILITY_VOB_PROCESSING_RETRY_MINUTES. */
  retryMinutes?: number;
  'test-id'?: string;
}

function AvailityLoader(props: AvailityLoaderProps) {
  const {
    showLoader,
    customMessage,
    retryMinutes,
    'test-id': testId = 'availity-loader',
  } = props;
  const minutes = retryMinutes ?? getAvailityVobProcessingRetryMinutes();

  if (!showLoader) {
    return null;
  }

  return (
    <Paper className="availity-loader" elevation={1}>
      <div className="availity-loader__body" test-id={testId}>
        <CircularProgress size={28} />
        <div className="availity-loader__text">
          <Typography variant="subtitle2" component="p">
            {customMessage ?? 'Running Availity VOB'}
          </Typography>
          <Typography className="availity-loader__time" variant="body2" component="span">
            {formatAvailityLoaderTimeWarn(minutes)}
          </Typography>
        </div>
      </div>
    </Paper>
  );
}

export default AvailityLoader;
